import { Jsona } from 'jsona';

export const jsonApiFormatter = new Jsona();
